var React = require('react');

function IconSocialFacebookBlack (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#242424","key":0}),React.createElement("path",{"d":"M24.8202 21.1605L25.4203 17.248H21.6664V14.7091C21.6664 13.6387 22.1909 12.5953 23.8722 12.5953H25.5789V9.26436C25.5789 9.26436 24.0301 9 22.5491 9C19.4574 9 17.4367 10.8738 17.4367 14.266V17.248H14V21.1605H17.4367V31C18.1813 31 18.832 31 19.5516 31C20.2711 31 20.9152 31 21.6664 31V21.1605H24.8202Z","fill":"white","key":1})]);
}

IconSocialFacebookBlack.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IconSocialFacebookBlack;

IconSocialFacebookBlack.default = IconSocialFacebookBlack;
